module.exports = __webpack_public_path__ + "img/central-bank.9e843dad.png";